<template>
  <div class="smash_eggs_container">
    <div class="smash_eggs_box">
      <div class="smash_eggs_tips"><span class="tips">您有<span class="remain_times" v-text="remainTime"></span>次抽奖机会</span></div>
      <div class="smash_eggs_area" @click="smashEggs"></div>
      <div class="smash_eggs_hammer" id="hammerHandler">
        <img :src="require('@/assets/images/raffle/egg_hammer.png')">
      </div>
      <div class="operate_box">
        <span class="operate_btn" @click="showAwards=true">
          <span class="btn_icon btn_icon_gift"></span>
          <span>奖品列表</span>
        </span>
        <span class="operate_btn" @click="showMyPrizeHandler">
          <span class="btn_icon btn_icon_money"></span>
          <span>我的奖品</span>
        </span>
        <span class="operate_btn" @click="showRules=true">
          <span class="btn_icon btn_icon_warn"></span>
          <span>抽奖规则</span>
        </span>
      </div>
    </div>
    <!-- 我的奖品 -->
    <van-popup :style="{ width: '80%', height: '351px', overflow: 'hidden', backgroundColor: '#fff9d9', borderRadius: '10px' }" v-model="showMyPrize" v-if="!!detail">
      <div class="my_prize_box">
        <div class="my_prize_title">我的奖品</div>
        <span class="close" @click="showMyPrize=false">
          <Icon iconClass="close_round" />
        </span>
        <div class="prize_table_title">
          <span class="time">中奖时间</span>
          <span class="name">奖品</span>
          <span class="btn_span">兑奖</span>
        </div>
        <div class="prize_content">
          <ul class="prize_list">
            <li class="prize_item" v-for="(item,index) in myPrizeList" :key="index">
              <span class="time" v-text="item.drawTime.substring(0,10)"></span>
              <span class="name" v-text="item.awardName"></span>
              <span class="btn_span" v-if="item.luckerStatus==0">
                <span class="btn btn_recipient" v-if="item.addressee.length>0 && item.expressPhone.length>0 && item.expressAddress.length>0" @click="recipientInfo(item)">查看</span>
                <span class="btn" @click="showAcceptHandler(item)" v-else>兑奖</span>
              </span>
              <span class="btn_span" v-else-if="item.luckerStatus==1">
                <span class="btn btn_dis">已兑</span>
              </span>
              <span class="btn_span" v-else><span class="btn btn_dis">放弃</span></span>
            </li>
          </ul>
        </div>
      </div>
    </van-popup>
    <!-- 兑奖 -->
    <van-popup :style="{ width: '80%', height: 'auto', overflow: 'hidden', backgroundColor: '#fff9d9', borderRadius: '10px' }" v-model="showAccept">
      <div class="dj_box">
        <van-tabs class="tabbar" @click="onDJTabClick" :line-width="'60px'">
          <van-tab title="现场兑奖"></van-tab>
          <van-tab title="邮寄奖品"></van-tab>
        </van-tabs>
        <div class="dj_content">
          <div class="mail_address_box" v-if="isMail">
            <p class="inputInfoTitle">请输入收件信息</p>
            <div class="recipientName">
              <label>收件人：</label>
              <input class="nameInput" autocomplete="off" v-model="curPrize.addressee" type="text" placeholder="请输入收件人姓名">
            </div>
            <div class="phoneDiv">
              <label>手机号：</label>
              <input class="phoneInput" autocomplete="off" v-model="curPrize.expressPhone" type="text" placeholder="请输入手机号号码">
            </div>
            <div class="recipientAddress">
              <label>收件地址：</label>
              <input class="addressInput" autocomplete="off" v-model="curPrize.expressAddress" type="text" placeholder="请输入收件地址">
            </div>
            <span class="submitTijiao" @click="acceptPrizeByMail">确定</span>
          </div>
          <div class="prize_code_box" v-else>
            <p class="inputInfoTitle">请输入兑奖码</p>
            <div class="prizeCode">
              <label>兑奖码：</label>
              <input class="codeInput" type="text" v-model="prizeCode" placeholder="请输入兑奖码">
            </div>
            <div class="tips">注：兑奖码可与主办方沟通获得！</div>
            <span class="submitTijiao" @click="acceptPrizeByCode">确定</span>
          </div>
        </div>
      </div>
    </van-popup>
    <!-- 奖项设置 -->
    <van-popup :style="{ width: '80%', height: '72%', overflow: 'hidden', backgroundColor: '#fff9d9', borderRadius: '10px' }" v-model="showAwards" v-if="!!detail">
      <div class="awards_box">
        <div class="awards_title">奖项设置</div>
        <span class="close" @click="showAwards=false">
          <Icon iconClass="close_round" />
        </span>
        <div class="award_content">
          <ul class="award_list">
            <li class="award_item" v-for="(item,index) in awards" :key="index">
              <div class="award_title"><span v-text="index+1"></span>）<span v-text="item.awardName"></span></div>
              <div class="award_img">
                <img :src="item.resourceUrl" alt="">
              </div>
              <div class="award_description" v-text="item.details"></div>
            </li>
          </ul>
        </div>
      </div>
    </van-popup>
    <!-- 抽奖规则 -->
    <van-popup :style="{ width: '80%', height: '72%', overflow: 'hidden', backgroundColor: '#fff9d9', borderRadius: '10px' }" v-model="showRules" v-if="!!detail">
      <div class="rules_box">
        <div class="rules_title">抽奖规则</div>
        <span class="close" @click="showRules=false">
          <Icon iconClass="close_round" />
        </span>
        <div class="rule_content" v-html="detail.details"></div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { deepClone, testMobilePhone } from "@/utils";
import raffleApi from "@/api/apis/raffle.js";
export default {
  name: "SmashEggs",
  props: {
    detailInfo: {
      type: Object,
      default: null,
    },
    freeFlag: {
      type: Number,
      default: 0,
    },
    awards: {
      type: Array,
      default: [],
    },
  },
  watch: {
    detailInfo: {
      handler(newValue, oldValue) {
        if (!!newValue) {
          this.detail = deepClone(newValue);
          this.raffleId = this.detail.id;
          if (this.freeFlag == 1) {
            this.remainTime = 1;
          } else {
            this.getRaffleTimes();
          }
        }
      },
      deep: true,
    },
  },
  computed: {
    ...mapState("app", ["userInfo", "nodeCode"]),
  },
  data() {
    return {
      detail: null, // 详情
      raffleId: 0, // 抽奖Id
      remainTime: 0, // 抽奖剩余次数
      failedMsg: ['很遗憾，什么都没抽到！', "不要灰心，加油加油！", "谢谢参与，祝您好运！"], // 未中奖弹窗提示语
      showMyPrize: false, // 显示我的奖品
      myPrizeList: [], // 我的中奖记录
      showAwards: false, // 显示奖项
      showRules: false, // 显示抽奖规则
      showAccept: false, // 显示兑奖弹窗
      isMail: false, // 是否邮寄，默认现场兑奖
      curPrize: null, // 当前的兑奖数据
      prizeCode: "", // 兑奖码
    };
  },
  methods: {
    /* 获取剩余抽奖次数 */
    getRaffleTimes() {
      var _this = this;
      raffleApi
        .getDrawRaffleTimes({ drawRaffleId: _this.raffleId, memberId: _this.userInfo.id })
        .then((res) => {
          if (res.suc == 1) {
            _this.remainTime = res.data.surplusTimes;
          } else {
            _this.remainTime = 0;
          }
        })
        .catch((err) => {
          _this.$toast({
            message: "接口调用出错",
            position: "center",
          });
        });
    },
    /* 获取我的及时抽奖中奖奖品 */
    getListAwardLogsByMemberId() {
      var _this = this;
      raffleApi
        .listAwardLogsByMemberId({
          code: _this.nodeCode,
          memberId: _this.userInfo.id,
          pageNo: 0,
          pageSize: 100,
        })
        .then((res) => {
          if (res.suc == 1) {
            _this.myPrizeList = res.data.list;
          }
        })
        .catch((err) => {
          _this.$toast({
            message: "接口调用出错",
            position: "center",
          });
        });
    },
    /* 砸金蛋 */
    smashEggs() {
      var _this = this;
      var hammer = document.getElementById('hammerHandler');
      if (_this.remainTime <= 0) {
        _this.$dialog.alert({ message: "您的次数已经用完！" });
        return;
      } else {
        hammer.style.display = "block";
        setTimeout(function () {
          hammer.style.display = "none";
          _this.doRaffle();
        }, 3000)
      }
    },
    /* 抽奖 */
    doRaffle() {
      var _this = this;
      var parmas = {
        drawRaffleId: _this.raffleId,
        memberId: _this.userInfo.id,
        surplusTimes: _this.remainTime,
        freeFlag: _this.freeFlag,
      }
      raffleApi
        .doDrawRaffle(parmas)
        .then((res) => {
          if (res.suc == 1 && res.data.result == 1) {
            _this.$dialog.alert({ message: "恭喜您，获得" + res.data.awardName });
          } else {
            var i = Math.floor(Math.random() * _this.failedMsg.length);
            _this.$dialog.alert({ message: _this.failedMsg[i] });
          }
          if (_this.freeFlag == 1) {
            _this.remainTime = 0;
          } else {
            _this.getRaffleTimes();
          }
        })
        .catch((err) => {
          _this.$toast({
            message: "接口调用出错",
            position: "center",
          });
        });
    },
    /* 现场兑奖/邮寄兑奖 tab切换 */
    onDJTabClick(index) {
      if (index == 0) {
        this.isMail = false;
      } else {
        this.isMail = true;
      }
    },
    /* 显示兑奖弹窗 */
    showAcceptHandler(data) {
      this.showAccept = true;
      this.curPrize = data;
    },
    /* 查看邮寄地址 */
    recipientInfo(data) {
      this.showAccept = true;
      this.curPrize = data;
    },
    /* 兑奖码兑奖 */
    acceptPrizeByCode() {
      var _this = this;
      var code = _this.curPrize.drawTime.substring(11, 19).replace(/:/g, '');
      if (_this.prizeCode == '') {
        _this.$toast({
          message: "请输入兑奖码!",
          position: "center",
        });
        return;
      } else if (code != _this.prizeCode) {
        _this.$toast({
          message: "您输入的兑奖码不正确",
          position: "center",
        });
        return;
      } else {
        raffleApi
          .acceptPrize({ awardLogsId: _this.curPrize.id })
          .then((res) => {
            if (res.suc == 1) {
              _this.$dialog
                .alert({ message: "兑奖成功！" })
                .then(() => {
                  _this.showAccept = false;
                  _this.prizeCode == '';
                  _this.curPrize.luckerStatus = 1;
                });
            }
          })
          .catch((err) => {
            _this.$toast({
              message: "接口调用出错",
              position: "center",
            });
          });
      }
    },
    /* 邮寄奖品兑奖 */
    acceptPrizeByMail() {
      var _this = this;
      if (_this.curPrize.addressee == '') {
        _this.$toast({
          message: "请输入收件人!",
          position: "center",
        });
        return;
      } else if (_this.curPrize.expressPhone == '') {
        _this.$toast({
          message: "您输入手机号!",
          position: "center",
        });
        return;
      } else if (_this.curPrize.expressAddress == '') {
        _this.$toast({
          message: "请输入收件地址!",
          position: "center",
        });
        return;
      } else if (!testMobilePhone(_this.curPrize.expressPhone)) {
        _this.$toast({
          message: "请填写正确的手机号码!",
          position: "center",
        });
        return;
      } else {
        raffleApi
          .awardSaveExpressInfo({
            awardLogsId: _this.curPrize.id,
            addressee: _this.curPrize.addressee,
            expressPhone: _this.curPrize.expressPhone,
            expressAddress: _this.curPrize.expressAddress,
          })
          .then((res) => {
            if (res.suc == 1) {
              _this.$dialog
                .alert({ message: "保存成功！" })
                .then(() => {
                  _this.showAccept = false;
                });
            }
          })
          .catch((err) => {
            _this.$toast({
              message: "接口调用出错",
              position: "center",
            });
          });
      }
    },
    /* 显示我的奖品 */
    showMyPrizeHandler() {
      this.showMyPrize = true;
      this.getListAwardLogsByMemberId();
    },
  },
  created() {

  },
  mounted() {
    if (!!this.detailInfo) {
      this.detail = deepClone(this.detailInfo);
      this.raffleId = this.detail.id;
      if (this.freeFlag == 1) {
        this.remainTime = 1;
      } else {
        this.getRaffleTimes();
      }
    }
  }
};
</script>
<style scoped lang="scss">
.smash_eggs_container {
  width: 100%;
  height: 100%;
  padding: 0px;
  background-color: #f3efc9;
  overflow-x: hidden;
  overflow-y: auto;
  .smash_eggs_box {
    position: relative;
    width: 100%;
    min-height: 150vw;
    background-repeat: no-repeat;
    background-position: center top;
    background-size: 100% auto;
    background-image: url(~@/assets/images/raffle/egg_bg.png);
    /* 提示语 */
    .smash_eggs_tips {
      position: absolute;
      left: 0;
      top: 40vw;
      width: 100%;
      height: auto;
      color: #fff;
      text-align: center;
      font-size: 12px;
      .tips {
        padding: 5px 10px;
        background-color: rgba(0, 0, 0, 0.3);
        border-radius: 15px;
        .remain_times {
          color: #ffe21f;
          margin-left: 5px;
          margin-right: 5px;
        }
      }
    }
    /* 蛋 */
    .smash_eggs_area {
      position: absolute;
      left: 33.4375%;
      top: 54vw;
      width: 33.125%;
      padding-bottom: 41.25%;
      background-repeat: no-repeat;
      background-position: center top;
      background-size: 100% auto;
      background-image: url(~@/assets/images/raffle/egg.png);
    }
    /* 锤子 */
    .smash_eggs_hammer {
      position: absolute;
      top: 25vw;
      right: 22%;
      width: 28%;
      z-index: 10002;
      display: none;
      img {
        display: block;
        width: 100%;
        -moz-transform-origin: 80% 80%;
        -webkit-transform-origin: 80% 80%;
        transform-origin: 80% 80%;
        -moz-transform: rotate(-40deg);
        -ms-transform: rotate(-40deg);
        -webkit-transform: rotate(-40deg);
        transform: rotate(-40deg);
        -moz-animation: chuizi 1s ease 3;
        -webkit-animation: chuizi 1s ease 3;
        animation: chuizi 1s ease 3;
      }
    }
    @keyframes chuizi {
      0% {
        -moz-transform: rotate(-40deg);
        -ms-transform: rotate(-40deg);
        -webkit-transform: rotate(-40deg);
        transform: rotate(-40deg);
      }
      50% {
        -moz-transform: rotate(0deg);
        -ms-transform: rotate(0deg);
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
      }
      100% {
        -moz-transform: rotate(-40deg);
        -ms-transform: rotate(-40deg);
        -webkit-transform: rotate(-40deg);
        transform: rotate(-40deg);
      }
    }
    @-webkit-keyframes chuizi {
      0% {
        -moz-transform: rotate(-40deg);
        -ms-transform: rotate(-40deg);
        -webkit-transform: rotate(-40deg);
        transform: rotate(-40deg);
      }
      50% {
        -moz-transform: rotate(0deg);
        -ms-transform: rotate(0deg);
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
      }
      100% {
        -moz-transform: rotate(-40deg);
        -ms-transform: rotate(-40deg);
        -webkit-transform: rotate(-40deg);
        transform: rotate(-40deg);
      }
    }
    @-moz-keyframes chuizi {
      0% {
        -moz-transform: rotate(-40deg);
        -ms-transform: rotate(-40deg);
        -webkit-transform: rotate(-40deg);
        transform: rotate(-40deg);
      }
      50% {
        -moz-transform: rotate(0deg);
        -ms-transform: rotate(0deg);
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
      }
      100% {
        -moz-transform: rotate(-40deg);
        -ms-transform: rotate(-40deg);
        -webkit-transform: rotate(-40deg);
        transform: rotate(-40deg);
      }
    }
    /* btns 奖项设置和抽奖规则 */
    .operate_box {
      position: absolute;
      bottom: 10px;
      left: 4%;
      right: 4%;
      z-index: 5;
      display: flex;
      width: 92%;
      .operate_btn {
        flex: 1;
        height: 80px;
        line-height: 40px;
        background-color: #fff;
        margin-left: 10px;
        margin-right: 10px;
        text-align: center;
        color: #040404;
        font-size: 16px;
        .btn_icon {
          display: block;
          width: 30px;
          height: 30px;
          margin: 10px auto 0;
          background-repeat: no-repeat;
          background-position: center center;
          background-size: contain;
          &.btn_icon_gift {
            background-image: url(~@/assets/images/raffle/egg_icon_gift.png);
          }
          &.btn_icon_money {
            background-image: url(~@/assets/images/raffle/egg_icon_money.png);
          }
          &.btn_icon_warn {
            background-image: url(~@/assets/images/raffle/egg_icon_warn.png);
          }
        }
      }
    }
  }
  /* 我的奖品列表 */
  .my_prize_box {
    position: relative;
    width: 100%;
    height: 100%;
    padding: 0;
    overflow: hidden;
    .my_prize_title {
      padding: 15px 15px 10px;
      color: #ff8000;
      text-align: center;
      font-size: 18px;
      font-weight: bold;
    }
    .close {
      position: absolute;
      right: 15px;
      top: 15px;
      .tj-svg-icon {
        color: #ff8000;
        font-size: 20px;
      }
    }
    .prize_table_title {
      padding: 0 15px 10px;
      font-weight: bold;
      .time {
        display: inline-block;
        width: 100px;
        text-align: center;
      }
      .name {
        display: inline-block;
        width: 40%;
        text-align: center;
      }
      .btn_span {
        display: inline-block;
        width: calc(60% - 100px);
        text-align: center;
      }
    }
    .prize_content {
      width: 100%;
      height: calc(100% - 80px);
      padding: 0 15px 15px;
      overflow-x: hidden;
      overflow-y: auto;
      .prize_list {
        .prize_item {
          line-height: 32px;
          font-size: 14px;
          .time {
            display: inline-block;
            width: 100px;
            text-align: center;
          }
          .name {
            display: inline-block;
            width: 40%;
            text-align: center;
          }
          .btn_span {
            display: inline-block;
            width: calc(60% - 100px);
            text-align: center;
            .btn {
              padding: 5px 10px;
              background: orange;
              color: #fff;
              font-size: 12px;
              border-radius: 3px;
              &.btn_dis {
                background: gray;
                opacity: 0.5;
              }
              &.btn_recipient {
                background: orangered;
              }
            }
          }
        }
      }
    }
  }
  /* 兑奖弹窗 */
  .dj_box {
    .tabbar {
      /deep/.van-tabs__nav {
        background: #fff9d9;
      }
    }
    .dj_content {
      padding: 5px 15px 15px;
      .prize_code_box,
      .mail_address_box {
        width: 100%;
        height: auto;
        .inputInfoTitle {
          width: 100%;
          height: 40px;
          line-height: 40px;
          color: #ff8000;
          text-align: center;
          font-weight: bold;
          font-size: 20px;
          font-family: "Microsoft YaHei";
        }
        .prizeCode,
        .recipientName,
        .phoneDiv {
          height: 40px;
          line-height: 40px;
          label {
            width: 64px;
            font-size: 16px;
          }
          .codeInput,
          .nameInput,
          .phoneInput,
          .addressInput {
            width: 70%;
            height: 32px;
            outline: none;
            border: none;
            font-family: "Microsoft YaHei";
            text-indent: 5px;
            background: transparent;
            border-bottom: 1px solid #000;
            color: #000;
          }
        }
        .recipientAddress {
          height: 40px;
          line-height: 40px;
          label {
            width: 80px;
            font-size: 16px;
          }
          .addressInput {
            width: calc(70% - 16px);
            height: 32px;
            outline: none;
            border: none;
            font-family: "Microsoft YaHei";
            text-indent: 5px;
            background: transparent;
            border-bottom: 1px solid #000;
            color: #000;
          }
        }
        .tips {
          line-height: 40px;
          line-height: 40px;
          color: orangered;
          font-size: 13px;
        }
        .submitTijiao {
          display: block;
          width: 80%;
          height: 32px;
          line-height: 32px;
          background: #00c957;
          margin: 20px auto 0;
          color: #fff;
          text-align: center;
          font-size: 16px;
          font-family: "Microsoft YaHei";
          -moz-border-radius: 2px;
          -webkit-border-radius: 2px;
          border-radius: 2px;
          cursor: pointer;
          outline: none;
        }
      }
    }
  }
  /* 奖项设置 */
  .awards_box {
    position: relative;
    width: 100%;
    height: 100%;
    padding: 0;
    overflow: hidden;
    .awards_title {
      padding: 15px 15px 10px;
      color: #ff8000;
      text-align: center;
      font-size: 18px;
      font-weight: bold;
    }
    .close {
      position: absolute;
      right: 15px;
      top: 15px;
      .tj-svg-icon {
        color: #ff8000;
        font-size: 20px;
      }
    }
    .award_content {
      width: 100%;
      height: calc(100% - 50px);
      padding: 0 15px 15px;
      overflow-x: hidden;
      overflow-y: auto;
      .award_list {
        .award_item {
          margin-bottom: 10px;
          .award_title {
            margin-bottom: 5px;
            line-height: 24px;
            color: #646464;
            font-weight: bolder;
          }
          .award_img {
            padding: 0 10px;
            margin-bottom: 5px;
            img {
              display: block;
              max-width: 100%;
            }
          }
          .award_description {
            line-height: 24px;
            padding: 0 10px;
          }
        }
      }
    }
  }
  /* 抽奖规则 */
  .rules_box {
    position: relative;
    width: 100%;
    height: 100%;
    padding: 0;
    overflow: hidden;
    .rules_title {
      padding: 15px 15px 10px;
      color: #ff8000;
      text-align: center;
      font-size: 18px;
      font-weight: bold;
    }
    .close {
      position: absolute;
      right: 15px;
      top: 15px;
      .tj-svg-icon {
        color: #ff8000;
        font-size: 20px;
      }
    }
    .rule_content {
      width: 100%;
      height: calc(100% - 50px);
      padding: 0 15px 15px;
      overflow-x: hidden;
      overflow-y: auto;
      word-break: normal;
      color: #646464;
      line-height: 25px;
      /deep/img {
        display: block;
        max-width: 100%;
        height: auto;
        margin: 5px auto;
      }
    }
  }
}
@media screen and (min-width: 750px) {
  .smash_eggs_container {
    .smash_eggs_box {
      min-height: 1125px;
      .smash_eggs_tips {
        top: 30px;
      }
      .smash_eggs_area {
        top: 405px;
      }
      .smash_eggs_hammer {
        top: 187.5px;
      }
    }
  }
}
</style>